import { Documents, PaymentKo, PaymentOk } from "src/ui/fragments";
import { useCheckoutResult } from "./checkout-result.hook";
import { StripeCheckoutStatus } from "src/types";

export const CheckoutResult = () => {
  const { checkoutSuccess, email } = useCheckoutResult();

  return (
    <div>
      <div className="container my-5 min-vh-100">
        {checkoutSuccess === StripeCheckoutStatus.COMPLETE && email ? (
          <PaymentOk email={email} />
        ) : (
          <PaymentKo />
        )}
      </div>
      <div className="px-3 py-5 p-md-5 bg-white">
        <div className="container">
          <Documents />
        </div>
      </div>
    </div>
  );
};
